import { Route, Routes } from 'react-router-dom'
import { InboxId, InboxLayout, Root } from 'src/pages/main/inbox'

export const InboxRoutes = () => {
  return (
    <Routes>
      <Route element={<InboxLayout />}>
        <Route index element={<Root />} />
        <Route path={':id'} element={<InboxId />} />
      </Route>
    </Routes>
  )
}
